import actionCable from 'actioncable'

const createConsumer = id => actionCable.createConsumer(`/cable?id=${id}`)

export default createConsumer
